import React from 'react';
import { Link } from 'react-router-dom';
import useViewerIdentity from '../../hooks/useViewerIdentity';
import './VerifyEmailBanner.css';

/**
 * Persistent banner shown at the top of the page when the logged-in user's email
 * is not yet verified. Links to the profile settings where they can resend the
 * verification email. Hidden on auth pages (login/register/verify) to avoid noise.
 */
const VerifyEmailBanner = () => {
  const { user } = useViewerIdentity();

  if (!user || user.emailVerified) return null;

  return (
    <div className="verify-email-banner" role="status">
      <span className="verify-email-banner__text">
        Please verify your email address to unlock commenting, rating, and posting.
      </span>
      <Link to="/profile?tab=settings&subtab=account" className="verify-email-banner__link">
        Verify now
      </Link>
    </div>
  );
};

export default VerifyEmailBanner;
